import React from "react";

import Facebook from '../svg/facebok-logo.svg'
import Odnoklassniki from '../svg/odonklassniki-logo.svg';
import Instagram from '../svg/instagram-logo.svg';
import Subscription from "./Subscription";
import IncrementIcon from "../svg/expand-icon.svg";
import LinkedInIcon from "../svg/linkedin.svg";

import '../styles/components/Footer.css';

export default function Footer() {

  return (
    <>
      <div className="footer_container">
        <h3 className="footer_header">SIGN UP FOR UPDATES</h3>
        <p className="footer_LabelForInput">Sign up for exclusive early sale access and tailored new arrivals.</p>
        <Subscription />
        <div className="footer_lists_container">
          <div className="footer_lists_container_1block">
            <img src={IncrementIcon} alt="IncrementIcon" className="IncrementIcon_customer_service" />
            <h4>CUSTOMER SERVICE</h4>
            <li>CONTACT</li>
            <li>TRACK ORDER</li>
            <li>DELIVERY & RETURNS</li>
            <li>PAYMENT</li>
            <li>MAKE A RETURN</li>
            <li>FAQ</li>
          </div>
          <div className="footer_lists_container_2block_div">
            <img src={IncrementIcon} alt="IncrementIcon" className="IncrementIcon_info" />
            <h4 className="footer_lists_container_2block">INFO</h4>
            <li>GIFT VOUCHERS</li>
            <li>SIZE GUIDE</li>
            <li>CAREERS AT MODNIKKY</li>
            <li>ABOUT US</li>
            <li>LEGAL POLICIES</li>
          </div>
          <div className="footer_lists_container_3block_div">
            <img src={IncrementIcon} alt="IncrementIcon" className="IncrementIcon_follow" />
            <h4 className="footer_lists_container_3block">FOLLOW US</h4>
            <div className="Footer_Li_with_icon">
              <img src={Facebook} alt="Facebook" className="Facebook_svg"/>
              <li>FACEBOOK</li>
            </div>
            <div className="Footer_Li_with_icon">
              <img src={Odnoklassniki} alt="ODNOKLASSNIKI" className="Odnoklassniki_svg"/>
              <li>ODNOKLASSNIKI</li>
            </div>
            <div className="Footer_Li_with_icon">
              <img src={Instagram} alt="Instagram" className="Instagram_svg"/>
              <li>INSTAGRAM</li>
            </div>
          </div>
          <div className="footer_lists_container_contact_us">
            <img src={IncrementIcon} alt="IncrementIcon" className="IncrementIcon_contact" />
            <h4>CONTACT US</h4>
            <li>hello@modnikky.com</li>
            <li>+7 910 832 26XX</li>
            <li>Visit us at Shalalaeva 23,<br/> Bologoe, Russia</li>
          </div>
        </div>
        <div className="footer_credit">
          Designed & built by Lolita Malinovskaya, follow my{" "}

          <a
              href="https://www.linkedin.com/in/lolita-malinovskaya-by"
              target="_blank"
              rel="noopener noreferrer"
          >
            <img src={LinkedInIcon} alt="LinkedInIcon" className="LinkedInIcon_svg" />
            LinkedIn
          </a>
        </div>
      </div>
      </>
      )
      }
